export default __webpack_public_path__ + "static/media/ornament_3.8b326a67.png";